import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { interval, Subject, takeUntil } from 'rxjs';
import { ProfileService, StyleService } from '../../services';
import { MatDialog } from '@angular/material/dialog';

import { JoinGoDecoratorDrawing } from '../../models/drawing';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar/snackbar.component';
@Component({
  selector: 'app-joingodrawing-card',
  templateUrl: './joingodrawing-card.component.html',
  styleUrls: ['./joingodrawing-card.component.scss'],
})
export class JoingodrawingCardComponent {

  @Output() activationCompleted = new EventEmitter<any>();
  
  @Input()
  public tab: any;

  @Input()
  public item: any;

  @Input()
  public mainTemplate: any;

  @Input()
  public indexes: [any, any] = [] as any;

  public isLoading = false;

  public joingoDrawing: JoinGoDecoratorDrawing[] = [];

  public buttonIsDisabled = false;

  public slides: any[] | undefined;
  public bError = true;
  public itemsPerPage: number = 6;
  private destroy$ = new Subject<void>();

  constructor(
    public styleService: StyleService,
    public readonly profileService: ProfileService,
    public dialog: MatDialog,
    private readonly cdk: ChangeDetectorRef,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    interval(60000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.checkAndActivateButtons();
      });
  }

  private checkAndActivateButtons(): void {

    this.getButtonState(this.item);

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private handleActivationError(drawingCMS: any, message: string) {

  console.error('Activation error: ', message);

  this.bError = true;

  drawingCMS.buttonIsDisabled = false;

  // Prefer custom error from builder if provided in tab.configurations.main.errorActivateDrawingText
  const customErrorText =
    this.tab?.configurations?.main?.errorActivateDrawingText?.trim();

  const snackbarMessage =
    customErrorText && customErrorText.length > 0
      ? customErrorText
      : message || 'Drawing error occurred.';

  // Show snackbar for 3 seconds
  this.snackBar.openFromComponent(SnackbarComponent, {
    panelClass: 'error',
    duration: 3000, // 3 seconds
    horizontalPosition: 'end',
    data: {
      type: 'error',
      message: snackbarMessage,
    },
  });
  
  // Notify parent so it can hide any spinners/overlays
  this.activationCompleted.emit({ success: false, message });
}

  public async activateJoingoDrawing(drawingCMS: any) {

  // start loading and disable the button
  this.isLoading = true;
  drawingCMS.buttonIsDisabled = true;

    try {
      const response =
        await this.profileService.universalConnector.getJoinGoDrawingActivate(
          this.playerProfile.playerId,
          drawingCMS?.universalConnectorData.id
        );

      // extra safety: only treat 200 as success from Joingo side
    if (response.crmHttpStatusCode && response.crmHttpStatusCode !== 200) {
      const code = response.crmHttpStatusCode;
      const msgFromErrors = response.errors?.[0]?.message;
      const msg =
        msgFromErrors ||
        response.message ||
        `Activation failed (CRM code ${code}).`;

      this.handleActivationError(drawingCMS, msg);
      return;
    }

 //  Hard error returned by backend---
    if (response?.error) {
      this.handleActivationError(drawingCMS, response.error);
      return;
    }

    const message: string = response?.message ?? '';

    const msgLower = message.toLowerCase();

    // errors[] from backend, as per OC-444 Joingo returns Array with error messages or an empty array if no errors occurred
    const hasBackendErrors = Array.isArray(response?.errors) && response.errors.length > 0;
    const backendErrorMessage = hasBackendErrors && response.errors[0]?.message
      ? response.errors[0].message
      : message || 'Unknown activation error.';
      
    if (!message || msgLower.startsWith('failed') || msgLower.includes('expired') || hasBackendErrors) {
      this.handleActivationError(drawingCMS, backendErrorMessage);
      return;
    }

 // SUCCESS path ---
    console.log('Activation success: ', message);

    this.bError = false;
    this.slides = [...(this.slides ?? [])];

    // mark drawing as activated
    drawingCMS.isActivated = true;
    drawingCMS.universalConnectorData.state = 'Activated';

    // button should now appear as Activated state
    drawingCMS.buttonIsDisabled = true;

    this.cdk.detectChanges();
    // let parent know activation completed successfully
    this.activationCompleted.emit({ success: true, message });


      // if (response?.error) {
      //   console.error('Response Error:', response.error);
      //   this.bError = true;
      // } else {
      //   console.log('Response:', response.message);
      //   if (response.message.toLowerCase().startsWith('fail')) {
      //     this.bError = true;
      //     this.activationCompleted.emit();
      //   } else {
      //     this.bError = false;
      //     this.slides = [...(this.slides ?? [])];
      //     drawingCMS.isActivated = true;
      //     drawingCMS.universalConnectorData.state = 'Activated'
      //     this.cdk.detectChanges();

      //     this.activationCompleted.emit();
      //     this.isLoading = false;

      //   }
      // }
    // } catch (error: any) {
    //   console.error('Error:', error);
    // }

    } catch (error: any) {

      console.error('Activation request failed:', error);

      const status = error?.status;
      const errorMessage = status
        ? `Activation failed (HTTP ${status}). Please try again.`
        : 'Unable to activate drawing. Please try again.';
      
      this.handleActivationError(drawingCMS, errorMessage);

    } finally {
    // ALWAYS clear loading flag so kiosk doesn’t “hang”
    this.isLoading = false;
    this.cdk.detectChanges();
  }

  }


  getButtonState(drawing: JoinGoDecoratorDrawing): string {
    this.item.buttonIsDisabled = true;

    const now = new Date();
    const conductAt = new Date(drawing?.universalConnectorData.conductAt);
    const earnStart = new Date(drawing?.universalConnectorData.earnStart);
    const earnEnd = new Date(drawing?.universalConnectorData.earnEnd);
    const checkinStart = new Date(drawing?.universalConnectorData.checkinStart);
    const checkinEnd = new Date(drawing?.universalConnectorData.checkinEnd);

    if (conductAt <= now) {
      this.item.buttonIsDisabled = true;
      return ''; // Return an empty string indicating no button should be shown.
    }

    // 2. Between earnStart and checkinStart, state should always be Pre-Active.
    if (now >= earnStart && now < checkinStart) {
      this.item.buttonIsDisabled = true;
      return 'preActive';
    }

    // 3. Between checkinStart and checkinEnd, button status is determined by state and entry.
    if (now >= checkinStart && now <= checkinEnd) {      
      if (drawing?.universalConnectorData.state !== 'Activated') {
        this.item.buttonIsDisabled = false;
        return 'activate'; // Otherwise, show 'activate' if the state is not 'Activated'
      } else {
        this.item.buttonIsDisabled = true;
        return 'activated'; // Hide the button if the state is 'Activated'
      }
    }

    // 4. Between checkinEnd and conductAt, button should not be visible.
    if (now > checkinEnd && now < conductAt) {
      if (drawing?.universalConnectorData.state !== 'Activated') {
        this.item.buttonIsDisabled = true;
        return '';
      } else {
        this.item.buttonIsDisabled = true;
        return 'activated';
      }
    }

    // 5. At exactly conductAt, the button will be removed from the screen completely.
    return ''; // Default case to handle any conditions not covered above.
  }

  public get playerProfile() {
    return this.profileService.playerProfile;
  }
}



